import React from 'react';

import Unfulfilled from '../../components/unfulfilled';

const Dashboard = () => {
    return <Unfulfilled />;
};

export default Dashboard;
